__webpack_require__.p = "/minter/";